import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from './SoundAssetKeys';
import Phaser from 'phaser';

/** @type {Phaser.Sound.HTML5AudioSound} */
let jingle = null;

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function setup(scene) {
  jingle = ABCyaPhaser.Audio.createSound(scene);
}

/**
 * 
 * @param {Phaser.Scene} scene you only need to pass in the scene if you want the fade to occur
 * @param {number} fade 
 * @returns 
 */
export function playJingle(scene, fade = 0) {
  scene?.tweens.killTweensOf(jingle);
  if (!jingle.isPlaying)ABCyaPhaser.Audio.playSound(SoundAssetKeys._Jingle_01, jingle, scene !== null && scene !== undefined && fade > 0 ? 0 : 1, true);

  if (scene !== null && scene !== undefined && fade > 0) {
    scene.tweens.add({ targets: jingle, duration: fade, props: { volume: 1 }, ease: Phaser.Math.Easing.Quadratic.Out });
  }
}

export function musicDown(scene, value) {
  scene.tweens.killTweensOf(jingle);

  scene.tweens.add({ targets: jingle, duration: 1000, props: { volume: value ?? 0.2 }, ease: Phaser.Math.Easing.Linear });
}

export function musicUp(scene, value) {
  scene.tweens.killTweensOf(jingle);

  scene.tweens.add({ targets: jingle, duration: 1000, props: { volume: value ?? 1 }, ease: Phaser.Math.Easing.Linear });
}

/**
 * 
 * @param {Phaser.Scene} scene you only need to pass in the scene if you want the fade to occur
 * @param {number} fade 
 * @returns 
 */
export function stopJingle(scene, fade = 0) {
  if (!jingle.isPlaying) return;

  scene?.tweens.killTweensOf(jingle);
  if (scene !== null && scene !== undefined && fade > 0) {
    scene.tweens.add({ targets: jingle, duration: fade, props: { volume: 0 }, ease: Phaser.Math.Easing.Quadratic.In, onComplete: () => jingle.stop() });
  }
  else {
    jingle.stop();
  }
}